import PropTypes from 'prop-types';

import PrivacyChangeList from './PrivacyChangeList';

const PrivacyChangeLightbox = ({ privacyChanges, onAccept }) => {
  const acceptChanges = (evt) => {
    evt.preventDefault();

    onAccept();
  };

  return <div className="backdrop">
    <article className="lightbox">
      <h2>Endringer i personvern</h2>

      <p>
        Hei! Vi har gjort endringer i personvernerklæringen vår. Du finner en oppsummering under.
        <br/>
        Ved å fortsette og bruke ibok.no samtykker du til gjeldende personvernerklæring.
        Du kan når som helst slette brukeren din fra <a href="innstillinger">innstillinger</a>,
        og all informasjon om deg vil bli fjernet eller anonymisert innen 90 dager.
      </p>

      <PrivacyChangeList changes={privacyChanges}/>

      <p>
        Personvernerklæringen og brukervilkårene kan du lese i sin helhet på siden
        for <a href="personvern">personvernerklæring</a> og <a href="betingelser">brukervilkår</a>
      </p>

      <form
        className="columns right buttons" onSubmit={acceptChanges}>
        <button type="submit">Forstått</button>
      </form>
    </article>
  </div>;
};

PrivacyChangeLightbox.propTypes = {
  privacyChanges: PropTypes.array.isRequired,
  onAccept: PropTypes.func.isRequired,
};

export default PrivacyChangeLightbox;
